// LEGACY: Uses SCSS with CSS modules. New code should use @metarouter-private/mr-mui components instead.
// LEGACY: Uses @ion/components. New code should use @metarouter-private/mr-mui components instead.
import React from 'react';
import pt from 'prop-types';

import { MrCard, MrInputText } from '@ion/components';
import { Stack, Typography } from '@metarouter-private/mr-mui';

import PrimaryClusterIndicator from './PrimaryClusterIndicator';
import styles from './card.module.scss';

export default function ClusterCard({ cluster }) {
  return (
    <MrCard className={styles.card}>
      <Stack spacing={1}>
        <PrimaryClusterIndicator clusterId={cluster.id} />
        <MrInputText disabled={true} value={cluster.name ?? ''} name="name" label="Cluster Name" fullWidth />
        <MrInputText
          disabled={true}
          value={cluster.url.replace(/(^\w+:|^)\/\//, '') ?? ''}
          name="url"
          label="Cluster URL"
          prefix="https://"
          fullWidth
        />
        <MrInputText
          disabled={true}
          value={cluster.metricNames?.join(', ') ?? ''}
          name="metricNames"
          label="Cluster Metric Names"
          fullWidth
        />
        <Stack spacing={0.5} direction="row">
          <Typography variant="h6" component="span" color="text.disabled">
            {'Pipelines:'}
          </Typography>
          <Typography variant="h6" fontWeight="normal" component="span" color="text.disabled">
            {cluster.connectedPipelines}
          </Typography>
        </Stack>
      </Stack>
    </MrCard>
  );
}

ClusterCard.propTypes = {
  cluster: pt.object,
};
